exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.section[data-v-70a30bc4] {\n  border-bottom: solid 2px black;\n  text-align: center;\n  margin: 10px 5% 10px 5%;\n  padding-bottom: 20px;\n}\n.section-description[data-v-70a30bc4] {\n  font-size: 18px;\n  margin-bottom: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-70a30bc4","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Mobile/ReschedulingPage/SpReceiverCompletion.vue
// module id = 530
// module chunks = 0